export const ReasonForReferral = [
    { value: 'Treaty', label: 'Treaty' },
    { value: 'FAC', label: 'FAC' },
    { value: '2nd Opinion', label: '2nd Opinion' },
];
